import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=cfd8ff30&"
import script from "./ShareLink.vue?vue&type=script&lang=js&"
export * from "./ShareLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfd8ff30')) {
      api.createRecord('cfd8ff30', component.options)
    } else {
      api.reload('cfd8ff30', component.options)
    }
    module.hot.accept("./ShareLink.vue?vue&type=template&id=cfd8ff30&", function () {
      api.rerender('cfd8ff30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/media/ShareLink.vue"
export default component.exports